import {
  Collapse,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { AppTheme } from "../context/MainContextProvider";
import { DashboardContext } from "../../modules/dashboard/context/DashboardContexProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faChartColumn,
  faCloudSun,
} from "@fortawesome/free-solid-svg-icons";
import { MiniCard, MiniCardProps } from "./MiniCard";
import { CardTypesEnum } from "../../modules/dashboard/types";
import MultilineChartIcon from "@mui/icons-material/MultilineChart";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";

const miniCardsProps: MiniCardProps[] = [
  {
    type: CardTypesEnum.PRRealizado,
    children: "12,34%",
    subtitle: "PR Realizado",
  },
  {
    type: CardTypesEnum.PerformanceRatio,
    children: "0,4",
    subtitle: "Performance Ratio",
  },
  {
    type: CardTypesEnum.EnergiaGerada,
    children: "123",
    subtitle: "Energia Gerada",
  },
  {
    type: CardTypesEnum.ValorGerado,
    children: "12,34 R$",
    subtitle: "Valor Gerado",
  },
  {
    type: CardTypesEnum.Disponibilidade,
    children: "12,34 %",
    subtitle: "Disponibilidade",
  },
  {
    type: CardTypesEnum.Ambiente,
    children: <FontAwesomeIcon icon={faCloudSun} />,
    subtitle: "Ambiente",
  },
  {
    type: CardTypesEnum.EvolucaoGeracao,
    children: <FontAwesomeIcon icon={faChartColumn} />,
    subtitle: "Geração de Energia",
    extraType: CardTypesEnum.GeracaoPlanta,
  },
  {
    type: CardTypesEnum.EnergiaAcumulada,
    children: <FontAwesomeIcon icon={faChartColumn} />,
    subtitle: "Energia Acumulada",
  },
  {
    type: CardTypesEnum.DiagramaPerdas,
    children: <FontAwesomeIcon icon={faChartColumn} />,
    subtitle: "Diagrama de Perdas (MWh)",
  },
  {
    type: CardTypesEnum.EnergiaAcumEnergiaCert,
    subtitle: "Energia Gerada x Energia Certificada",
  },
  {
    type: CardTypesEnum.Produtividade,
    children: <FontAwesomeIcon icon={faChartColumn} />,
    subtitle: "Produtividade",
  },
  {
    type: CardTypesEnum.Pareto,
    children: <FontAwesomeIcon icon={faChartColumn} />,
    subtitle: "Pareto",
  },
  {
    type: CardTypesEnum.TensaoDeLinha,
    children: "11.45",
    subtitle: "Tensão de Linha",
  },
  {
    type: CardTypesEnum.Tracker,
    children: <MultilineChartIcon />,
    subtitle: "Tracker",
  },
  {
    type: CardTypesEnum.Heatmap,
    children: <LocalFireDepartmentIcon />,
    subtitle: "Heat Map - Potência Ativa por Inversor",
  },
  {
    type: CardTypesEnum.PotenciaAtiva,
    children: "123",
    subtitle: "Potência Ativa",
  },
];

export function CardsAdder(props: {
  theme: AppTheme;
  disabled?: boolean;
  isAccordionitem?: boolean;
}) {
  const { theme, isAccordionitem } = props;
  const { selectedUsinaHasTrackers } = useContext(DashboardContext);
  const [isExpanded, setIsExpanded] = useState(false);

  const availableCards = useMemo(
    () =>
      selectedUsinaHasTrackers === true
        ? miniCardsProps
        : miniCardsProps.filter(
            (card) => card.type !== CardTypesEnum.Tracker,
          ),
    [selectedUsinaHasTrackers],
  );

  useEffect(() => {
    if (props.disabled) {
      setIsExpanded(false);
    }
  }, [props.disabled]);
  return (
    <>
      <ListItem disablePadding>
        <ListItemButton
          sx={{
            paddingLeft: isAccordionitem ? "32px" : undefined,
            borderRadius: "10px",
            height: "45px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
          }}
          disabled={props.disabled}
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          <div className="pe-2">
            <FontAwesomeIcon
              size="sm"
              icon={faAngleRight}
              color={theme.iconsColor}
              style={{
                transform: isExpanded ? "rotate(90deg)" : "",
                transition: "all 0.2s linear",
              }}
              rotate={"90deg"}
            />
          </div>

          <ListItemText primary="Adicionar Itens" />
        </ListItemButton>
      </ListItem>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <div className="d-flex flex-row justify-content-around flex-wrap">
          {availableCards.map((props, index) => (
            <MiniCard key={index} {...props} />
          ))}
        </div>
      </Collapse>
    </>
  );
}
